<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'data.product.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateProduct"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'data.product.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteProduct"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['product'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteProduct() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('product/delete', this.product.id);
          this.$store.dispatch('product/fetchAllWithPagination');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateProduct() {
        this.$router.push('/data/products/update/' + this.product.id);
      }
    }
  };
</script>
